export const IDLE_TIMEOUT_SECONDS = 15 * 60;
export const ABSOLUTE_SESSION_SECONDS = 8 * 60 * 60;
export const SESSION_UPDATE_AGE_SECONDS = 60;
export const ACCESS_TOKEN_REFRESH_BUFFER_SECONDS = 5 * 60;
